<script>
import CodeEditor from '@/components/form-controls/CodeEditor';
import ContentBox from '@/components/ui/ContentBox';

export default {
  name: 'BlockForm',
  components: {
    CodeEditor,
    ContentBox
  },
  props: {
    data: Object,
    disabled: Boolean,
    invalid: Array,
    isNew: Boolean,
    saving: Boolean
  },
  data() {
    return {
      cleanState: {},
      form: {
        name: '',
        description: '',
        source: ''
      },
      testing: false
    };
  },
  created() {
    // Set the initial data
    if (this.data) {
      this.setData(this.data);
    }

    // Set the initial clean state
    this.resetCleanState();
  },
  methods: {
    // Returns the form's data
    getData() {
      return Object.assign({}, this.form);
    },

    // Sets the form's data
    setData(data) {
      Object.keys(this.form).forEach(key => {
        this.form[key] = typeof data[key] === 'undefined' ? this.form[key] : data[key];
      });
      this.resetCleanState();
      this.$nextTick(() => this.$refs.codeEditor.clearHistory());
    },

    // Tells if the current state is different than the clean state
    isDirty() {
      return JSON.stringify(this.cleanState) !== JSON.stringify(this.form);
    },

    // Sets the clean state to the current state
    resetCleanState() {
      this.cleanState = Object.assign({}, this.form);
    }
  }
};
</script>

<template>
  <el-form
    :disabled="disabled"
    class="block-form"
    label-position="top"
    @submit.native.prevent="$emit('submit')"
  >
    <content-box>
      <fieldset>
        <!-- Name -->
        <el-form-item
          :label="$t('Name')"
          :class="{ 'is-error': invalid.includes('name') }"
        >
          <el-input
            ref="name"
            v-model="form.name"
            type="text"
            auto-complete="off"
          />
        </el-form-item>

        <!-- Description -->
        <el-form-item
          :label="$t('Description')"
          :class="{ 'is-error': invalid.includes('description') }"
        >
          <el-input
            v-model="form.description"
            :rows="2"
            type="textarea"
            auto-complete="off"
          />
          <div class="text-form-description">
            {{ $t('Enter a brief description of this block.') }}
          </div>
        </el-form-item>

        <!-- Source -->
        <el-form-item
          :label="$t('Source')"
          :class="{ 'is-error': invalid.includes('source') }"
        >
          <code-editor ref="codeEditor" v-model="form.source" mode="html" />
          <div class="text-form-description">
            {{ $t('Drag and drop an HTML file or copy and paste the full source of your block.') }}
          </div>
        </el-form-item>
      </fieldset>
    </content-box>

    <div class="text-right">
      <!-- Cancel -->
      <el-button @click="$emit('cancel')">
        {{ $t('Cancel') }}
      </el-button>

      <!-- Submit -->
      <el-button :loading="saving" type="primary" native-type="submit">
        <span v-if="isNew">{{ $t('Create Block') }}</span>
        <span v-else>{{ $t('Save Changes') }}</span>
      </el-button>
    </div>
  </el-form>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

//
// No styles yet
//
</style>
